import React from 'react'
import Slider from 'react-slick'
import './beneficiosslider.css'
import styles from '../../ResumenADN.module.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BenefitCard from "../../../../components/BenefitCard";
import beneficiosStyles from "./beneficios.module.css";


const PrevArrow = (props) => {
  const { onClick } = props
  const hideArrow = props.currentSlide === 0
  const styleHide = hideArrow ? styles.arrowDisable : ''
  return (
    <div
      className={`${styles.arrowBox} ${styles.arrowBox__left} ${styles.arrowBox__leftB} ${styleHide}`}
      onClick={onClick}
    />
  )
}

const NextArrow = (props) => {
  const { onClick } = props
  const disableArrow = props.className === 'slick-arrow slick-next slick-disabled'
  const styleDisable = disableArrow ? styles.arrowDisable : ''
  return (
    <div
      className={`${styles.arrowBox} ${styles.arrowBox__right} ${styles.arrowBox__rightB} ${styleDisable}`}
      onClick={onClick}
    />
  )
}

const settings = {
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  className: "slider-beneficios",
  responsive: [
    {
      breakpoint: 570,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    }
  ]
}

const SliderBeneficios = ({ data }) => {
  return (
    data.length > 3 ?
    <Slider {...settings}>
      {data.map((item, index) => (
        <BenefitCard
            titulo={item.nombreBeneficio}
            descripcion={item.descBeneficio}
            linkTermCond={item.linkTermCond}
            id={item.idBeneficio}
            key={index}
        />
      ))}
    </Slider> : 
    <div className={beneficiosStyles.beneficios__wrapper}>
        {data.map((item, index) => (
        <BenefitCard
            titulo={item.nombreBeneficio}
            descripcion={item.descBeneficio}
            linkTermCond={item.linkTermCond}
            id={item.idBeneficio}
            key={index}
        />
      ))}
      </div>
  )
}

export default SliderBeneficios;
